require('./insuranceRequestRelatedWizardSaved.scss');
require('./insuranceRequestRelatedWizardSaved.override.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const InsuranceRequestPolicySummary = require('../insuranceRequestPolicySummary/insuranceRequestPolicySummary');

// @ constants
const { MORTGAGE_PANEL } = require('../../../insuranceConstants/insuranceRequestRoutes');
const { WORKFLOW_STATE } = require('../../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_IDD_REGULATION,
} = require('constants/flagBasedFeatures');
const processes = {
    PROC_PRE_APPRAISAL: "pre-tasacion",
    PROC_POST_APPRAISAL: "post-tasacion",
};

class InsuranceRequestRelatedWizardSaved extends React.Component {
    constructor(props) {
        super(props);
        this.handleGoBackToPanel = this.handleGoBackToPanel.bind(this);
    }

    componentWillMount() {
        const { getPaymentAccount, isRnc } = this.props;
        if (!isRnc) {
            getPaymentAccount();
        }
    }
    handleGoBackToPanel() {
        const { onModifyInsuranceAction } = this.props;
        onModifyInsuranceAction(false, false);
        this.props.history.push(MORTGAGE_PANEL);
    }

    isStateInvalidToModify() {
        const { appraisalState } = this.props;
        const stateInvalid = WORKFLOW_STATE.some(state => {
            return state === appraisalState;
        })
        return stateInvalid
    }

    buildContactCenterMandatoryReading() {
        const { isPostAppraisal, isRelated } = this.props;
        const poeditorPrefix = 'insuranceRequestHomeCC';
        const message = isRelated && isPostAppraisal
            ? `${poeditorPrefix}-${poeditorPrefix}_relatedMandatoryReadingStepSaved`
            : `${poeditorPrefix}-${poeditorPrefix}_mandatoryReadingStepSaved`;

        return __CONTACT_CENTER__
            ? (
                <BlockInfo
                    extraClass={'insurance-request-related-wizard-saved__block-info'}>
                    {formatText(message)}
                </BlockInfo>
            )
            : null;
    }

    formatHomeMixedMsgPrivate(poeKey){
        return !!poeKey && (
            <p className="insurance-request-related-wizard-saved__info">
                <FormattedText value={poeKey}/>
            </p>
        )
    }

    formatHomeMixedMsgCC(poeKey){
        return !!poeKey && (
            <BlockInfo extraClass={'insurance-request-related-wizard-saved__block-info'}>
                {formatText(poeKey)}
            </BlockInfo>
        )
    }

    buildHomeMixedSavedMessage() {
        const {immFlagBasedFeatures} = this.props;
        const POE_KEY_CC = 'insuranceRequestHome-insuranceRequestHome_savedHomeMixedCC';
        const POE_KEY_WEB = 'insuranceRequestHome-insuranceRequestHome_savedHomeMixedPrivate';
        let poeKey;

        if (immFlagBasedFeatures.get(INSURANCE_IDD_REGULATION)) {
            poeKey = __CONTACT_CENTER__ ? POE_KEY_CC : POE_KEY_WEB;
        }

        return __CONTACT_CENTER__
            ? this.formatHomeMixedMsgCC(poeKey)
            : this.formatHomeMixedMsgPrivate(poeKey);
    }

    render() {
        const {
            isPostAppraisal,
            isRelated,
            immInsuranceState,
            immInsuranceWizardState,
            immAccounts,
            hasSimulation,
            hasSimulationChanged,
            isRnc,
            onHandleModifyInsurance,
            insuranceHasBeenModified,
            notifyWrapUp
        } = this.props

        let insuranceSavedTitle = 'insuranceSavedTitle'
        if (isPostAppraisal) {
            insuranceSavedTitle = insuranceHasBeenModified ? 'insuranceSavedPostAppraisalModifiedTitle' : 'insuranceSavedPostAppraisalTitle';
        }

        let insuranceSavedDescription = 'insuranceSavedDescription'
        if (isPostAppraisal) {
            insuranceSavedDescription = insuranceHasBeenModified ? 'insuranceSavedPostAppraisalModifiedDescription' : 'insuranceSavedPostAppraisalDescription'
        }

        const successTitle = formatText(`insuranceRequestHome-${insuranceSavedTitle}`);
        const successDescription = <FormattedText value={`insuranceRequestHome-${insuranceSavedDescription}`} />;
        const GDPRMessage = formatText('insuranceRequestHome-insuranceSavedPostAppraisalDisclaimer');
        const linkToPanel = {
            label: formatText('insuranceRequestHome-returnToMortgagePanel')
        };
        const modifyInsuranceButton = {
            label: formatText('insuranceRequestHome-modifyInsurance')
        };
        const postAppraisalDisclaimer = !__CONTACT_CENTER__ && isPostAppraisal && !insuranceHasBeenModified &&
            <div className="insurance-request-related-wizard-saved__disclaimer">
                <OKMessage type="informative">
                    {GDPRMessage}
                </OKMessage>
            </div>
        const isLimitsFlagEnabled = !__CONTACT_CENTER__ && immInsuranceState.getIn(['data', 'ccLimitsFlag']);
        const showSecondaryButton = !isLimitsFlagEnabled && isPostAppraisal && !this.isStateInvalidToModify() && modifyInsuranceButton;
        const successDescriptionAppraisal = !__CONTACT_CENTER__ && !isPostAppraisal && (
            <div className="insurance-request-related-wizard-saved__messages">
                <p className="insurance-request-related-wizard-saved__messages-text">{successDescription}</p>
            </div>
        );
        const successDescriptionPostappraisal = isPostAppraisal ? successDescription : null;
        const ccMandatoryReading = this.buildContactCenterMandatoryReading();
        const processDetail = isPostAppraisal
            ? processes.PROC_POST_APPRAISAL
            : processes.PROC_PRE_APPRAISAL;
        return (
            <div className="insurance-request-related-wizard-saved">
                <WizardSuccess
                    onMainButtonClick={this.handleGoBackToPanel}
                    mainButton={linkToPanel}
                    processDetail={processDetail}
                    secondaryButton={showSecondaryButton}
                    onSecondaryButtonClick={onHandleModifyInsurance}
                    successMessage={successTitle}
                    successSubMessage={successDescriptionPostappraisal}
                    notifyWrapUp={notifyWrapUp}
                >
                    {successDescriptionAppraisal}
                    {ccMandatoryReading}
                    {postAppraisalDisclaimer}
                    <InsuranceRequestPolicySummary
                        isRelated={isRelated}
                        immInsuranceState={immInsuranceState}
                        immInsuranceWizardState={immInsuranceWizardState}
                        immAccounts={immAccounts}
                        hasSimulation={hasSimulation}
                        hasSimulationChanged={hasSimulationChanged}
                        isRnc={isRnc}
                        isPostAppraisal={isPostAppraisal}
                    />
                    {this.buildHomeMixedSavedMessage()}
                </WizardSuccess>
            </div>
        )
    }
}

InsuranceRequestRelatedWizardSaved.propTypes = {
    isPostAppraisal: PropTypes.bool.isRequired,
    isRelated: PropTypes.bool,
    immInsuranceState: PropTypes.object,
    immInsuranceWizardState: PropTypes.object,
    immAccounts: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    hasSimulation: PropTypes.bool,
    hasSimulationChanged: PropTypes.bool,
    isRnc: PropTypes.bool.isRequired,
    getPaymentAccount: PropTypes.func,
    onHandleModifyInsurance: PropTypes.func,
    onModifyInsuranceAction: PropTypes.func,
    appraisalState: PropTypes.string,
    insuranceHasBeenModified: PropTypes.bool.isRequired,
    notifyWrapUp: PropTypes.bool,
    history: PropTypes.object.isRequired,
}


InsuranceRequestRelatedWizardSaved.defaultProps = {
    isRnc: false,
    getPaymentAccount: () => { },
    onHandleModifyInsurance: () => { },
    onModifyInsuranceAction: () => { },
    notifyWrapUp: true,
}

module.exports = withRouter(InsuranceRequestRelatedWizardSaved);
